import qs from 'qs'
import { MODE, BASEURL } from '@/utils'

// 获取登录token（目前由于没有跨域，暂时这么获取）
let userToken = localStorage.getItem('userToken')
let base_url = BASEURL
let [lv1, lv2] = location.host.split('.')
const userPath = lv1 === 'www' ? lv2 : lv1

// 默认的请求headers
let defaultHeaders = {
  token: userToken,
  from: 'public-navigation',
  'Content-Type': 'application/json',
  'X-company-domain': userPath === 'eline56' || MODE === 'dev' ? 'app' : userPath
}

const ajax = async (url, data, opts = {}) => {
  opts.headers = Object.assign({}, defaultHeaders, opts.headers)
  if (!opts.method || opts.method === 'get') {
    let query = data ? qs.stringify(data) : ''
    url = url ? `${url}?${query}` : url
  } else {
    opts.body = JSON.stringify(data || {})
    opts.headers['Content-Type'] = 'application/json'
  }
  let res = await fetch(url, opts)
  // 错误处理
  if (res.code !== 0 && !res.success) {
    return res.json()
  }
  return res.json().data
}

export default ajax
